import sortPositionsByTerrainPreferences from './sortPositionsByTerrainPreferences.js';
export default function getNeighboursByTerrainPreferences(position, rules, mapHexes, terrainPreferences) {
    const neighbours = rules.getExistingNeighbours(position);
    return sortPositionsByTerrainPreferences(neighbours, mapHexes, terrainPreferences);
}
